import React from 'react';
import ClimateImpactAnalysis from '../components/CarbonFootprint/ClimateImpactAnalysis';

const ClimateImpact = () => {
  return <ClimateImpactAnalysis />;
};

export default ClimateImpact;
